import { getPanelIDFromConfigPath } from 'api/actions'
import { HistoryUpdate } from 'api/history'
import * as Model from 'api/model'

/**
 * Updates the URL
 * @param {string} panelConfigPath Empty string will clear url param
 */
export default function PanelExpanded (panelConfigPath) {
  let panelid = ''
  if (panelConfigPath && panelConfigPath !== '') {
    panelid = getPanelIDFromConfigPath(panelConfigPath)
  }
  const panelState = Model.getState('panel', '')
  if (panelState === '' && panelid === '') {
    // Don't bother updating the state, it's already blank.
    return
  }
  Model.setState('panel', null, panelid)
  HistoryUpdate()
}
